<template>
    <div :class="[`justify-content-${align}`, `align-items-${alignItems}`]"
        :style="{ minHeight }"
        class="d-flex">
        <div :class="[`spinner-${spinnerType}`, `text-${color}`, `m-${margin}`]"
            :style="{ width: `${size}rem`, height: `${size}rem` }" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Spinner',

    props: {
        minHeight: { type: String, default: '100%' },
        spinnerType: { type: String, default: 'border' },
        color: { type: String, default: 'primary' },
        margin: { type: Number, default: 5 },
        align: { type: String, default: 'center' },
        alignItems: { type: String, default: 'center' },
        size: { type: Number, default: 2 },
    }
}
</script>